import { computed } from "vue";
import useUser from "../authentication/useUser";
import useAccessibleScope from "../authentication/useAccessibleScope";

// Dashboard page title that names the organization only for a single
// region/organization scope. A cross-region or multi-organization user's scope
// spans several organizations, so the single `defaultOrganization` name would
// misrepresent it — those users get the plain dashboard title. The org name is
// also dropped when it is unavailable (e.g. a platform/application admin whose
// scope carries no bounded organization).
export default function useDashboardTitle(label) {
  const { defaultOrganization } = useUser();
  const { hasCrossOrganizationScope } = useAccessibleScope();

  return computed(() => {
    const orgName = defaultOrganization.value?.name;
    if (hasCrossOrganizationScope.value || !orgName) return label;
    return `${orgName} ${label}`;
  });
}
